import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import { includes, isArray, isNumber, reduce, isNaN } from 'lodash';
var MILITARY_DATE_FIELD_KEYS = ['entry_date', 'exit_date', 'deployment_starts_at', 'deployment_ends_at'];
function cleanMilitaryFields() {
  var military = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return reduce(military, function (acc, curr, key) {
    if (includes(MILITARY_DATE_FIELD_KEYS, key)) {
      var epoch = _parseInt(curr, 10);
      if (!isNumber(epoch) || isNaN(epoch)) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, null));
      }
    }
    if (key === 'proof_type') {
      if (isArray(curr)) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, ''));
      }
    }
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, curr));
  }, {});
}
export default cleanMilitaryFields;
//# sourceMappingURL=cleanMilitaryFields.js.map